module.exports = __webpack_public_path__ + "static/media/icon_shishigaoxiao_wap.c277fd49.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/icon_shishigaoxiao_wap.svg
// module id = 491
// module chunks = 0